import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import {InboxService} from './inbox.service';
import {InboxMessage} from '../model/inbox-message';
import {UserContextService} from './user-context.service';
import {MessageBoxService} from '../components/shared/message-box/message-box.service';
import {TranslateService} from '@ngx-translate/core';
import {FormatService} from './format.service';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private http = inject(HttpClient);
  private inbox = inject(InboxService);
  private userContext = inject(UserContextService);
  private messageBoxService = inject(MessageBoxService);
  private translateService = inject(TranslateService);
  private formatService = inject(FormatService);
  private storage = inject(StorageService);


  checkUnreadMessages(): void {
    if (!this.userContext.isInternalUser()) {
      const inss = this.userContext.getInss();
      const hasShownPopup = inss ? this.storage.getUnreadMessagesPopUp(inss) : null;

      if (hasShownPopup) {
        return;
      }

      this.getUnreadMessages().pipe(take(1)).subscribe({
        next: messages => {
          if (messages.length > 0) {
            this.showUnreadMessagesPopup(messages.length);
            if (inss) {
              this.storage.setUnreadMessagesPopUp(inss, 'true');
            }
          }
        },
        error: err => console.error('[MessageService] Error fetching unread messages:', err)
      });
    }
  }

  getUnreadMessages(): Observable<InboxMessage[]> {
    if (this.userContext.isInternalUser()) {
      const inss = this.userContext.getInss();
      return this.inbox.getInboxMessages({ssin: inss || '', status: 'UNREAD'});
    } else {
      return this.inbox.getMyInboxMessages({status: 'UNREAD'});
    }
  }

  private showUnreadMessagesPopup(messagesNumber: number): void {
    this.translateService.get('INBOX.unread_messages_alert').pipe(take(1)).subscribe({
      next: (translatedText: string) => {
        this.messageBoxService.showModal('INBOX.unread_messages_title',
          this.formatService.formatMessage(translatedText, [messagesNumber, '/unemployment/inbox']),
          'INBOX.dialog_ok',
          '');
      },
      error: err => console.error('[MessageService] Error translating unread messages alert:', err)
    });
  }
}
